module.exports = __webpack_public_path__ + "media/excellusbcbs-home-viewports@lg-4039fe5229167b3e268f391ed0595094.png";